import { render } from "./PageRules.vue?vue&type=template&id=5af8bda6"
import script from "./PageRules.vue?vue&type=script&lang=js"
export * from "./PageRules.vue?vue&type=script&lang=js"

import "./PageRules.vue?vue&type=style&index=0&id=5af8bda6&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.17.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__